import flowIcon from '../../app/icons/flow.png';

/**
 * Custom sidebar icon for FlowHub using the flow.png image.
 * Renders at 24x24 to match Material UI icon sizing used by other sidebar items.
 */
const FlowHubIcon = () => (
  <img
    src={flowIcon}
    alt="FlowHub"
    width={24}
    height={24}
    style={{ display: 'block' }}
  />
);

export default FlowHubIcon;
